import ApiClient from "@/api/ApiClient.ts";

const mockSubscriberInitial = {
  idWorkgroup: null,
  notes: "",
  reqs: [],
  cif: "",
  contactPhone: "",
  contactEmail: "",
  contactPerson: "",
  billingWayToPay: 1,
  billingDiscounts: 0,
  billingDate: 2,
  billingEmail: "",
  invoiceLines: 1,
  linePrice: 1,
  billingCustomFields: [
    { name: "Num despacho", id: 1, isDisabled: true },
    { name: "Fecha despacho", id: 2, isDisabled: true },
    { name: "Taxi", id: 5, isDisabled: true },
  ],
  fixedPrices: [],
  created: "",
  deleted: null,
  users: [],
  subscriberCustomFields: [],
  id: null,
  ref: "",
  name: "",
  billingIban: "",
  billingNotes: "",
  postalAddress: "",
  cp: "",
  town: "",
  province: "",
};

const state = {
  subscribers: [],
  subscriberById: null,
};

function sanitizeFixedPrices(sub) {
  if (typeof sub.fixedPrices === "string" && sub.fixedPrices.includes("{")) {
    try {
      sub.fixedPrices = JSON.parse(sub.fixedPrices);
    } catch {
      sub.fixedPrices = [];
    }
  }
  return sub;
}

const mutations = {
  setSubscribers(state, subscribers) {
    state.subscribers = subscribers;
  },

  setSubscriberById(state, subscriber) {
    state.subscriberById = subscriber;
  },

  resetMockSubscriberId(state) {
    state.subscriberById = mockSubscriberInitial;
  },
};

const actions = {
  async getSubscribers({ commit }, customParams) {
    if (!customParams.wgId) return [];
    const params = {
      ...customParams,
    };
    try {
      let subscribers = (await ApiClient().get("subscribers", { params })).data.flat();
      subscribers = subscribers.map((s) => sanitizeFixedPrices(s));
      commit("setSubscribers", subscribers);
      return subscribers;
    } catch (error) {
      console.error("ERROR en getSubscribers: ", error.message);
    }
  },

  async retrieveSubscriberById(_, params) {
    return ApiClient()
      .get("subscribers", { params })
      .then((res) => res.data)
      .then((sub) => {
        return sanitizeFixedPrices(sub);
      });
  },

  async getSubscriberById({ commit }, params) {
    try {
      let { data } = await ApiClient().get("subscribers", { params });
      if (!data.billingWayToPay) {
        data.billingWayToPay = 1;
      }
      if (!data.billingDiscounts) {
        data.billingDiscounts = 0;
      }
      if (!data.billingDate) {
        data.billingDate = 2;
      }
      if (!data.invoiceLines) {
        data.invoiceLines = 1;
      }
      if (!data.linePrice) {
        data.linePrice = 1;
      }
      if (!data.billingCustomFields) {
        data.billingCustomFields = [
          { name: "Num despacho", id: 1, isDisabled: true },
          { name: "Fecha despacho", id: 2, isDisabled: true },
          { name: "Taxi", id: 5, isDisabled: true },
        ];
      }
      if (!data.subscriberCustomFields || !Array.isArray(data.subscriberCustomFields)) {
        data.subscriberCustomFields = [];
      }
      if (data.subscriberCustomFields.length > 0) {
        data.subscriberCustomFields = data.subscriberCustomFields.filter((cf) => cf.name);
      }
      if (!data.cp) {
        data.cp = "";
      }
      if (!data.province) {
        data.province = "";
      }
      if (!data.town) {
        data.town = "";
      }
      data = sanitizeFixedPrices(data);
      commit("setSubscriberById", data);
      return data;
    } catch (error) {
      console.error("ERROR en getSubscriberById: ", error.message);
    }
  },

  async createSubscriber(_, data) {
    delete data.created;
    delete data.createdHR;
    delete data.deleted;
    delete data.users;
    try {
      let response = await ApiClient().post("subscribers/sub", data);
      return response.data;
    } catch (error) {
      console.error("ERROR en createSubscriber: ", error.message);
    }
  },

  async updateSubscriber(_, payload) {
    delete payload.data?.users;
    delete payload.data?.created;
    delete payload.data?.createdHR;
    delete payload.data?.deleted;
    if (payload.data?.fixedPrices) {
      payload.data.fixedPrices = payload.data.fixedPrices.map((p) => {
        delete p.idForList;
        return p;
      });
    }
    try {
      await ApiClient().put("subscribers/sub", payload.data, {
        params: payload.params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateSubscriber: ", error.message);
      return false;
    }
  },

  async deleteSubscriber(_, params) {
    try {
      await ApiClient().delete("subscribers", { params });
      return true;
    } catch (error) {
      console.error("ERROR en deleteSubscriber: ", error.message);
      return false;
    }
  },

  async createUserSubscriber(_, data) {
    try {
      await ApiClient().post("subscribers/users", data);
      return true;
    } catch (error) {
      return false;
    }
  },

  async updateUserSubscriber(_, data) {
    try {
      await ApiClient().put("subscribers/users", data);
      return true;
    } catch (error) {
      console.error("ERROR en updateUserSubscriber: ", error.message);
      return false;
    }
  },

  async deleteUserSubscriber(_, params) {
    try {
      await ApiClient().delete("subscribers/users", { params });
      return true;
    } catch (error) {
      console.error("ERROR en deleteSubscriber: ", error.message);
      return false;
    }
  },
};

const getters = {
  subscribers(state) {
    return state.subscribers;
  },

  subscriberNameById: (state) => (id) => {
    const sub = state.subscribers.find((c) => c.id === id);
    if (sub) {
      return sub.name;
    }
  },

  subscribersWithoutDeleted(state) {
    return state.subscribers;
  },

  subscriberById(state) {
    return state.subscriberById;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
